import { IS_MOBILE } from "@/utils/tool";
import { useTranslation } from "react-i18next";
import "./index.scss";
import { FooterConfig } from "@/utils/contants";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer>
      <div>
        {t("客服邮箱")} :{" "}
        <a
          href="mailto:publink@cnpiec.com.cn"
          style={{ textDecoration: "none" }}
        >
          publink@cnpiec.com.cn
        </a>
      </div>
      <div>
        {FooterConfig.kefuPhone}
        {FooterConfig.onLineTime}
      </div>
      <div>
        Copyright©cnpiec.com.cn All Right Reserved
        {IS_MOBILE ? <br /> : " "}
        中国图书进出口（集团）有限公司版权所有
      </div>
      <div> 京ICP备09090397号-11</div>
    </footer>
  );
};

export default Footer;
